<div class="row p-3">
    <h1 mat-dialog-title>Update Guest Verification Results</h1>
    <div mat-dialog-content [formGroup]="form" class="p-3">
        <mat-card appearance="outlined" class="my-4">
            <div class="m-2">
                <div class="row mb-2 check-row" *ngIf="shouldDisplayScreeningResultColumns()">
                    <div class="col d-flex flex-column item-key detail-label fs-5">Screening Summary</div>
                    <div class="col d-flex flex-column item-key fs-5">Screening Details</div>
                    <div class="col d-flex flex-column item-key fs-5 mx-4"></div>
                    <div class="col d-flex flex-column item-key fs-5"></div>
                </div>
                <div class="row check-row my-3" *ngIf="shouldDisplayCheckType(guestVerificationCheckType.IDENTITY)">
                    <div class="col d-flex flex-column">
                        <div class="item-key detail-label mb-4">
                            Identity Check
                        </div>
                    </div>
                    <div class="col d-flex flex-column">
                        <div class="item-status text-center mb-4" [ngClass]="getVerificationResultColor(guestVerificationInfo.identityResultCode)">
                            {{ guestVerificationInfo.identityResultCode?.text?.toLowerCase() }}
                        </div>
                    </div>
                    <div class="col d-flex flex-column item-value mx-2">
                        <mat-form-field appearance="outline" >
                            <mat-label>Change To</mat-label>
                            <mat-select formControlName="identity_result">
                                <mat-option *ngFor="let verificationResult of guestVerificationResults" [value]="verificationResult.check_code">
                                    {{ verificationResult.status_text }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column item-value mx-2">
                        <div class="col d-flex flex-column">
                            <mat-form-field appearance="outline" >
                                <input type="text" matInput placeholder="Enter Note" formControlName="identity_note">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="row check-row my-3" *ngIf="shouldDisplayCheckType(guestVerificationCheckType.DOCUMENT)">
                    <div class="col d-flex flex-column">
                        <div class="item-key detail-label mb-4">
                            Document Check
                        </div>
                    </div>
                    <div class="col d-flex flex-column">
                        <div class="item-status text-center mb-4" [ngClass]="getVerificationResultColor(guestVerificationInfo.identityResultCode)">
                            {{ guestVerificationInfo.identityResultCode?.text?.toLowerCase() }}
                        </div>
                    </div>
                    <div class="col d-flex flex-column item-value mx-2">
                        <mat-form-field appearance="outline" >
                            <mat-label>Change To</mat-label>
                            <mat-select formControlName="document_result">
                                <mat-option *ngFor="let verificationResult of guestVerificationResults" [value]="verificationResult.check_code">
                                    {{ verificationResult.status_text }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column item-value mx-2">
                        <div class="col d-flex flex-column">
                            <mat-form-field appearance="outline" >
                                <input type="text" matInput placeholder="Enter Note" formControlName="document_note">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="row check-row my-3" *ngIf="shouldDisplayCheckType(guestVerificationCheckType.WATCHLIST)">
                    <div class="col d-flex flex-column">
                        <div class="item-key detail-label mb-4">
                            Terrorist & Financial Crime Watch Lists
                        </div>
                    </div>
                    <div class="col d-flex flex-column">
                        <div class="item-status text-center mb-4" [ngClass]="getVerificationResultColor(guestVerificationInfo.watchlistResultCode)">
                            {{ guestVerificationInfo.watchlistResultCode?.text?.toLowerCase() }}
                        </div>
                    </div>
                    <div class="col d-flex flex-column item-value">
                        <mat-form-field appearance="outline">
                            <mat-label>Change To</mat-label>
                            <mat-select formControlName="watchlist_result">
                                <mat-option *ngFor="let verificationResult of guestVerificationResults" [value]="verificationResult.check_code">
                                    {{ verificationResult.status_text }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column item-value">
                        <mat-form-field appearance="outline">
                            <input type="text" matInput placeholder="Enter Note" formControlName="watchlist_note">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row check-row my-3" *ngIf="shouldDisplayCheckType(guestVerificationCheckType.SEX_OFFENDER)">
                    <div class="col d-flex flex-column">
                        <div class="item-key detail-label mb-4">
                            U.S Sex Offender List
                        </div>
                    </div>
                    <div class="col d-flex flex-column">
                        <div class="item-status text-center mb-4" [ngClass]="getVerificationResultColor(guestVerificationInfo.sexOffenderResultCode)">
                            {{ guestVerificationInfo.sexOffenderResultCode?.text?.toLowerCase() }}
                        </div>
                    </div>
                    <div class="col d-flex flex-column item-value mx-4">
                        <mat-form-field appearance="outline">
                            <mat-label>Change To</mat-label>
                            <mat-select formControlName="sex_offender_result">
                                <mat-option *ngFor="let verificationResult of guestVerificationResults" [value]="verificationResult.check_code">
                                    {{ verificationResult.status_text }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column item-value">
                        <mat-form-field appearance="outline">
                            <input type="text" matInput placeholder="Enter Note" formControlName="sex_offender_note">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row check-row my-3" *ngIf="shouldDisplayCheckType(guestVerificationCheckType.BACKGROUND)">
                    <div class="col d-flex flex-column">
                        <div class="item-key detail-label mb-4">
                            U.S Criminal History
                        </div>
                    </div>
                    <div class="col d-flex flex-column">
                        <div class="item-status text-center mb-4" [ngClass]="getVerificationResultColor(guestVerificationInfo.nationalCriminalCode)">
                            {{ guestVerificationInfo.nationalCriminalCode?.text?.toLowerCase() }}
                        </div>
                    </div>
                    <div class="col d-flex flex-column item-value mx-4">
                        <mat-form-field appearance="outline">
                            <mat-label>Change To</mat-label>
                            <mat-select formControlName="criminal_result">
                                <mat-option *ngFor="let verificationResult of guestVerificationResults" [value]="verificationResult.check_code">
                                    {{ verificationResult.status_text }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column item-value">
                        <mat-form-field appearance="outline">
                            <mat-label>Notes</mat-label>
                            <input type="text" matInput placeholder="Enter Note" formControlName="criminal_note">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row check-row my-3" *ngIf="shouldDisplayCheckType(guestVerificationCheckType.FRAUD)">
                    <div class="col d-flex flex-column">
                        <div class="item-key detail-label mb-4">
                            Suspicious Behavior Check
                        </div>
                    </div>
                    <div class="col d-flex flex-column">
                        <div class="item-status text-center mb-4" [ngClass]="getVerificationResultColor(guestVerificationInfo.fraudResultCode)">
                            {{ guestVerificationInfo.fraudResultCode?.text?.toLowerCase() }}
                        </div>
                    </div>
                    <div class="col d-flex flex-column item-value mx-4">
                        <mat-form-field appearance="outline">
                            <mat-label>Change To</mat-label>
                            <mat-select formControlName="fraud_result">
                                <mat-option *ngFor="let verificationResult of guestVerificationResults" [value]="verificationResult.check_code">
                                    {{ verificationResult.status_text }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column item-value">
                        <mat-form-field appearance="outline">
                            <mat-label>Notes</mat-label>
                            <input type="text" matInput placeholder="Enter Note" formControlName="fraud_note">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row check-row mb-4" *ngIf="shouldDisplayCheckType(guestVerificationCheckType.BAD_GUEST)">
                    <div class="col d-flex flex-column">
                        <div class="item-key detail-label mb-4">
                            Safely Prior Rental Database
                        </div>
                    </div>
                    <div class="col d-flex flex-column">
                        <div class="item-status text-center mb-4" [ngClass]="getVerificationResultColor(guestVerificationInfo.badGuestResultCode)">
                            {{ guestVerificationInfo.badGuestResultCode?.text?.toLowerCase() }}
                        </div>
                    </div>
                    <div class="col d-flex flex-column item-value mx-4">
                        <mat-form-field appearance="outline">
                            <mat-label>Change To</mat-label>
                            <mat-select formControlName="bad_guest_result">
                                <mat-option *ngFor="let verificationResult of guestVerificationResults" [value]="verificationResult.check_code">
                                    {{ verificationResult.status_text }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column item-value">
                        <mat-form-field appearance="outline">
                            <input type="text" matInput placeholder="Enter Note" formControlName="bad_guest_note">
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </mat-card>
    </div>
    <div class="my-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" mat-dialog-close>
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-raised-button class="action-button" (click)="submitGuestVerificationResultDetail()">
            <mat-icon>check</mat-icon>
            Submit Changes
        </button>
    </div>
</div>